export class CampaignAsset {
  constructor(
    public readonly id: number,
    public readonly file: string,
    public readonly name: string,
    public readonly type: string,
    public readonly size: string,
  ) {}
}
